import { bool, string, array, object, oneOfType } from 'prop-types'
import { kuiperClassNames } from '../../utils'

import './styles.scss'

function classes(shouldValidate, valid, secondaryAction) {
  return kuiperClassNames('input-label', {
    valid,
    invalid: !valid,
    'no-validation': !shouldValidate,
    'secondary-action': secondaryAction,
  })
}

const Label = ({ inputId, secondaryAction, shouldValidate, text, valid }) => {
  if (text) {
    return (
      <label
        className={classes(shouldValidate, valid, secondaryAction)}
        htmlFor={inputId}
      >
        {text}
      </label>
    )
  }
  return null
}
Label.displayName = 'Kuiper: Label ← Inputs'

Label.propTypes = {
  inputId: string,
  secondaryAction: bool,
  shouldValidate: bool,
  text: oneOfType([array, string, object]),
  valid: bool,
}

export default Label
